import {
  DATA_DONE_TEXT,
  DATA_NONE_TEXT,
  DATA_PROCESSING_TEXT,
} from '@common/constant/data';
import {
  ACTION_COMEIN_ROOM_OPTION,
  ACTION_LEAVE_ROOM_OPTION,
  ACTION_OPTION_PREFIX,
  ACTION_OPTIONS,
  COMPANY_OPTION_PREFIX,
  LAYOUT_OPTION_PREFIX,
  USERNAME_OPTION_PREFIX,
} from '@common/constant/option';
import dayjs from 'dayjs';

export function flattenDataWithIdAndName(
  data,
  idKey,
  nameKey,
  nameOptions = {},
) {
  return (data || []).map((item) => ({
    id: item[idKey],
    name:
      Object.keys(nameOptions).length > 0
        ? nameOptions[item[idKey]]
        : item[nameKey],
  }));
}

export function makeUniqueItemOnArray(dataArray, key = 'id') {
  const uniqueObjects = dataArray.filter((data, index, self) => {
    const currentId = data[key];
    return self.findIndex((obj) => obj[key] === currentId) === index;
  });
  return uniqueObjects;
}

export function convertArrayToOptionFilter(dataArray, prefix = '') {
  const uniqueObjects = makeUniqueItemOnArray(dataArray);
  const childrenCompanyData = uniqueObjects.map((data) => ({
    label: data.name,
    value: `${prefix}${data.id}`,
    title: data.name,
    key: `${prefix}${data.id}`,
  }));
  return childrenCompanyData;
}

export function processFilterOptions(filterOptions) {
  // ユーザー名
  const dataUser = flattenDataWithIdAndName(
    filterOptions.users || [],
    'user_id',
    'username',
  );
  const childrenUserData = convertArrayToOptionFilter(
    dataUser,
    `${USERNAME_OPTION_PREFIX}_`,
  );

  // アクション
  const dataAction = flattenDataWithIdAndName(
    ACTION_OPTIONS,
    'events_type',
    '',
    {
      0: ACTION_COMEIN_ROOM_OPTION,
      1: ACTION_LEAVE_ROOM_OPTION,
    },
  );
  const childrenActionData = convertArrayToOptionFilter(
    dataAction,
    `${ACTION_OPTION_PREFIX}_`,
  );

  // 会社名
  const dataCompany = flattenDataWithIdAndName(
    filterOptions.companies || [],
    'company_id',
    'company_name',
  );
  const childrenCompanyData = convertArrayToOptionFilter(
    dataCompany,
    `${COMPANY_OPTION_PREFIX}_`,
  );

  // Fab名
  // const dataFab = flattenDataWithIdAndName(
  //   analyticData.map((item) => item.fab) || [],
  //   'id',
  //   'name',
  // );
  // const childrenFabData = convertArrayToOptionFilter(
  //   dataFab,
  //   `${FAB_OPTION_PREFIX}_`,
  // );

  // レイアウト名
  const dataLayout = flattenDataWithIdAndName(
    filterOptions.layouts || [],
    'layout_id',
    'layout_name',
  );
  const childrenLayoutData = convertArrayToOptionFilter(
    dataLayout,
    `${LAYOUT_OPTION_PREFIX}_`,
  );

  return {
    userOptions: childrenUserData || [],
    actionOptions: childrenActionData || [],
    companyOptions: childrenCompanyData || [],
    layoutOptions: childrenLayoutData || [],
    // fabOptions: childrenFabData || [],
  };
}

export const AddDataStatusToItem = (yearMonth, hasData = true) => {
  const month = dayjs(yearMonth).month() + 1;
  if (dayjs(yearMonth).isSame(dayjs(), 'month')) {
    return {
      value: month,
      year: dayjs(yearMonth).year(),
      label: `${String(month).padStart(2, '0')} (${DATA_PROCESSING_TEXT})`,
      disabled: false,
    };
  }
  return {
    value: month,
    label: `${String(month).padStart(2, '0')} (${
      hasData ? DATA_DONE_TEXT : DATA_NONE_TEXT
    })`,
    disabled: dayjs(yearMonth).isAfter(dayjs(), 'month'),
  };
};

export const GetMonthStatus = (options, value) => {
  const monthOptions = options?.flatMap((item) => item?.months || []) ?? [];
  const target = dayjs(value).format('YYYY-MM');
  const hasMonth = monthOptions.find((m) => m?.yearMonth === target);

  if (hasMonth) {
    if (dayjs(value).isSame(dayjs(), 'month')) return DATA_PROCESSING_TEXT;
    return hasMonth.hasData ? DATA_DONE_TEXT : DATA_NONE_TEXT;
  }
  return DATA_NONE_TEXT;
};
